/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StockGoodsListSkuItem } from './StockGoodsListSkuItem';
import {
    StockGoodsListSkuItemFromJSON,
    StockGoodsListSkuItemFromJSONTyped,
    StockGoodsListSkuItemToJSON,
    StockGoodsListSkuItemToJSONTyped,
} from './StockGoodsListSkuItem';

/**
 * 
 * @export
 * @interface StockGoodsListResVo
 */
export interface StockGoodsListResVo {
    /**
     * SPU主键ID
     * @type {number}
     * @memberof StockGoodsListResVo
     */
    spuId?: number;
    /**
     * 登录商品编号（SPU编码，页面显示用）
     * @type {string}
     * @memberof StockGoodsListResVo
     */
    spuCode?: string;
    /**
     * 商品名称
     * @type {string}
     * @memberof StockGoodsListResVo
     */
    productName?: string;
    /**
     * 
     * @type {Array<StockGoodsListSkuItem>}
     * @memberof StockGoodsListResVo
     */
    skus?: Array<StockGoodsListSkuItem>;
}

/**
 * Check if a given object implements the StockGoodsListResVo interface.
 */
export function instanceOfStockGoodsListResVo(value: object): value is StockGoodsListResVo {
    return true;
}

export function StockGoodsListResVoFromJSON(json: any): StockGoodsListResVo {
    return StockGoodsListResVoFromJSONTyped(json, false);
}

export function StockGoodsListResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): StockGoodsListResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'spuId': json['spuId'] == null ? undefined : json['spuId'],
        'spuCode': json['spuCode'] == null ? undefined : json['spuCode'],
        'productName': json['productName'] == null ? undefined : json['productName'],
        'skus': json['skus'] == null ? undefined : ((json['skus'] as Array<any>).map(StockGoodsListSkuItemFromJSON)),
    };
}

export function StockGoodsListResVoToJSON(json: any): StockGoodsListResVo {
    return StockGoodsListResVoToJSONTyped(json, false);
}

export function StockGoodsListResVoToJSONTyped(value?: StockGoodsListResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'spuId': value['spuId'],
        'spuCode': value['spuCode'],
        'productName': value['productName'],
        'skus': value['skus'] == null ? undefined : ((value['skus'] as Array<any>).map(StockGoodsListSkuItemToJSON)),
    };
}

